var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { staticClass: "home-footer" }, [
    _c("div", { staticClass: "home-footer-inner" }, [
      _vm.isHome
        ? _c("div", { staticClass: "subs-email" }, [
            _c("img", {
              directives: [
                {
                  name: "lazy",
                  rawName: "v-lazy",
                  value: require("../../../assets/images/email.png"),
                  expression: "require('../../../assets/images/email.png')"
                }
              ],
              staticClass: "email-png"
            }),
            _vm._v(" "),
            _c("div", [
              _c("p", { staticClass: "subs-title" }, [
                _vm._v(_vm._s(_vm.$t("travel_disc")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "input-outter" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.email,
                      expression: "email",
                      modifiers: { trim: true }
                    }
                  ],
                  staticClass: "input-inner",
                  attrs: {
                    type: "email",
                    placeholder: "Enter your email",
                    readonly: ""
                  },
                  domProps: { value: _vm.email },
                  on: {
                    "~click": function($event) {
                      _vm.relieveInput($event)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.email = $event.target.value.trim()
                    },
                    blur: function($event) {
                      _vm.$forceUpdate()
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "subs-btn",
                    on: { click: _vm.subscribleEmail }
                  },
                  [_vm._v(_vm._s(_vm.$t("subs_email")))]
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("ul", { staticClass: "sortcut-nav" }, [
        _c("li", { staticClass: "nav-item" }, [
          _c("h5", { staticClass: "nav-item-title" }, [
            _vm._v(_vm._s(_vm.$t("company")))
          ]),
          _vm._v(" "),
          _c("ul", [
            _c(
              "li",
              {
                staticClass: "list-item list-item-link",
                on: {
                  click: function($event) {
                    _vm.jump("/about")
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("about")))]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "list-item list-item-link",
                on: {
                  click: function($event) {
                    _vm.jump("/terms_of_conditions")
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("terms_service")))]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "list-item list-item-link",
                on: {
                  click: function($event) {
                    _vm.jump("/privacy_policy")
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("privacy_policy")))]
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "nav-item" }, [
          _c("h5", { staticClass: "nav-item-title" }, [
            _vm._v(_vm._s(_vm.$t("order_support")))
          ]),
          _vm._v(" "),
          _c("ul", [
            _c(
              "li",
              {
                staticClass: "list-item list-item-link",
                on: {
                  click: function($event) {
                    _vm.jump("/allhelp")
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("faq")))]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "list-item list-item-link",
                on: {
                  click: function($event) {
                    _vm.jump("/contact")
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("ct_us")))]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "list-item list-item-link",
                on: {
                  click: function($event) {
                    _vm.jump("/contact")
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("cor_contact")))]
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "nav-item", staticStyle: { flex: "3" } }, [
          _c("h5", { staticClass: "nav-item-title" }, [
            _vm._v(_vm._s(_vm.$t("pay_type")))
          ]),
          _vm._v(" "),
          _c("table", { staticClass: "table" }, [
            _c("tbody", [
              _c("tr", [
                _c("td", [
                  _c("img", {
                    directives: [
                      {
                        name: "lazy",
                        rawName: "v-lazy",
                        value: require("../../../assets/payment/visa2.png"),
                        expression:
                          "require('../../../assets/payment/visa2.png')"
                      }
                    ],
                    staticClass: "img-visa"
                  })
                ]),
                _vm._v(" "),
                _c("td", [
                  _c("img", {
                    directives: [
                      {
                        name: "lazy",
                        rawName: "v-lazy",
                        value: require("../../../assets/payment/paypal2.png"),
                        expression:
                          "require('../../../assets/payment/paypal2.png')"
                      }
                    ],
                    staticClass: "img-paypal"
                  })
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [
                  _c("img", {
                    directives: [
                      {
                        name: "lazy",
                        rawName: "v-lazy",
                        value: require("../../../assets/payment/mastercard.png"),
                        expression:
                          "require('../../../assets/payment/mastercard.png')"
                      }
                    ],
                    staticClass: "img-mastercard"
                  })
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "nav-item" }, [
          _c("h5", { staticClass: "nav-item-title" }, [
            _vm._v(_vm._s(_vm.$t("follow_us")))
          ]),
          _vm._v(" "),
          _vm._m(0)
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "nav-item" }, [
          _c("img", {
            directives: [
              {
                name: "lazy",
                rawName: "v-lazy",
                value: require("../../../assets/download.png"),
                expression: "require('../../../assets/download.png')"
              }
            ],
            staticClass: "download-img"
          }),
          _vm._v(" "),
          _c("p", { staticClass: "download-text" }, [
            _vm._v(
              "\n                    " +
                _vm._s(_vm.$t("download")) +
                "\n                    "
            ),
            _c("img", {
              directives: [
                {
                  name: "lazy",
                  rawName: "v-lazy",
                  value: require("../../../assets/images/ebbly_text.png"),
                  expression: "require('../../../assets/images/ebbly_text.png')"
                }
              ],
              staticClass: "ebbly-logo"
            })
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "home-footer-copyright" }, [
      _vm._v(
        "\n        Copyright © 2019 ebbly Inc. All Right Reserved\n        "
      ),
      _c(
        "a",
        {
          staticStyle: { color: "rgb(117, 185, 243)" },
          attrs: { href: "http://www.miitbeian.gov.cn/", target: "_blank" }
        },
        [_vm._v(_vm._s(_vm.copyRemark))]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("a", {
        staticClass: "icon icon-fb",
        attrs: {
          href: "https://www.facebook.com/ebblyofficial/",
          target: "_blank"
        }
      }),
      _vm._v(" "),
      _c("a", {
        staticClass: "icon icon-ins",
        attrs: {
          href: "https://www.instagram.com/ebblyofficial/",
          target: "_blank"
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12985b90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12985b90","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/components/Footer.vue
// module id = null
// module chunks = 